module.exports = __webpack_public_path__ + "fonts/museo-sans-500-webfont.f54ed82.woff2";